import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { RangesInfo } from '@/domain/newRequest';
import { COLOR, PX_TO_REM } from '@/globalStyles';

interface SummaryInfoProps {
    className?: string;
    summary: RangesInfo;
}

const SummaryInfo = ({ className, summary }: SummaryInfoProps) => {
    const { t } = useTranslation();
    return (
        <div className={className}>
            <ErrorOutlineIcon sx={{ color: COLOR.zambezi }} />
            <TextWrapper>
                <Typography variant="button">
                    {t(
                        summary.isCurrentAndFuture
                            ? 'newRequest_SummaryInfo_currentAndFuturePeriod'
                            : 'newRequest_SummaryInfo_futurePeriod',
                        {
                            futurePeriod: `[${summary.lastPeriodStartDate} - ${summary.lastPeriodEndDate}]`,
                            currentPeriod: `[${summary.currentPeriodStartDate} - ${summary.currentPeriodEndDate}]`,
                        }
                    )}
                </Typography>
            </TextWrapper>
        </div>
    );
};

const Memoized = memo(SummaryInfo);
const Styled = styled(Memoized)`
    display: flex;
    margin-top: ${PX_TO_REM[20]};
    background-color: ${COLOR.aliceBlue};
`;

const TextWrapper = styled.div`
    padding-left: ${PX_TO_REM[10]};
`;

Styled.displayName = 'SummaryInfo';
export default Styled;
